import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

interface Field {
  label: string
  value: ReactNode
}

interface Props {
  fields: Field[]
  problemManagement?: ReactNode
}

export function ContentManagementPanel({ fields, problemManagement }: Props) {
  const { t } = useTranslation('coaching')

  return (
    <section
      className="rounded-lg border border-gray-200 bg-white"
      data-testid="content-management"
      aria-label={t('contentManagement.title')}
    >
      <header className="border-b border-gray-100 px-4 py-3">
        <h2 className="text-sm font-semibold text-gray-900">{t('contentManagement.title')}</h2>
      </header>
      <div className="grid grid-cols-1 divide-y divide-gray-100 lg:grid-cols-[1fr_280px] lg:divide-x lg:divide-y-0">
        <div className="p-4">
          <h3 className="text-xs font-semibold text-gray-500">{t('contentManagement.basicInfo')}</h3>
          <dl className="mt-3 grid grid-cols-2 gap-3 md:grid-cols-4">
            {fields.map((field) => (
              <div key={field.label} className="min-w-0">
                <dt className="text-[11px] font-medium text-gray-400">{field.label}</dt>
                <dd className="mt-1 truncate text-sm font-medium text-gray-900">{field.value}</dd>
              </div>
            ))}
          </dl>
        </div>
        {problemManagement && (
          <div className="p-4">
            <h3 className="text-xs font-semibold text-gray-500">{t('contentManagement.problemManagement')}</h3>
            <div className="mt-3">{problemManagement}</div>
          </div>
        )}
      </div>
    </section>
  )
}
